module.exports = __webpack_public_path__ + "img/yuangou.a24ec81a.png";